<script>
import { required, email } from "vuelidate/lib/validators";
import swal from "sweetalert";
export default {
  data() {
    return {
      email: "",
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
    };
  },
  validations: {
    email: { required, email },
  },
  methods: {
    postData() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        const url = `${process.env.VUE_APP_BASE_URL}/auth/forgot-password`;
        this.$http
          .post(url, {
            email: this.email,
            authorizationType: "admin-authentication",
          })
          .then((res) => {// eslint-disable-line no-unused-vars
            swal(
              "Successful, Check Email !",
              "Please check your email for OTP code",
              "success"
            ).then((res) => {// eslint-disable-line no-unused-vars
              this.$router.push({
                name: "reset-password",
                params: { email: this.email },
              });
            });
          })
          .catch((err) => {// eslint-disable-line no-unused-vars
            swal(
              "Error!",
              "Failed to send reset email. Please try again.",
              "error"
            );
            this.submitted = false;
          });
      }
    },
  },
  created() {
    document.body.classList.add("auth-body-bg");
  },
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    </div>
    <div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-4 m-auto">
            <div
              class="authentication-page-content p-4 d-flex align-items-center min-vh-100"
            >
              <div class="w-100">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <div>
                      <div class="text-center">
                        <div>
                          <a href="/" class="logo">
                            <img
                              src="../../../assets/xefe.png"
                              height="170"
                              alt="logo"
                            />
                          </a>
                        </div>

                        <h4 class="font-size-18 mt-4">Reset Password</h4>
                        <h4 class="font-size-24 mt-4">Admin Dashboard</h4>
                        <p class="text-muted">
                          Enter your email address and we'll send you an OTP to
                          reset your password
                        </p>
                      </div>

                      <div class="p-2 mt-5">
                        <form
                          class="form-horizontal"
                          @submit.prevent="postData()"
                        >
                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-mail-line auti-custom-input-icon"></i>
                            <label for="useremail">Email Address</label>
                            <input
                              v-model="email"
                              type="email"
                              class="form-control"
                              id="useremail"
                              placeholder="Enter your email address"
                              :class="{
                                'is-invalid': submitted && $v.email.$error,
                              }"
                            />
                            <div
                              v-if="submitted && $v.email.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.email.required"
                                >Email is required.</span
                              >
                              <span v-if="!$v.email.email"
                                >Please enter valid email.</span
                              >
                            </div>
                          </div>

                          <div class="mt-4 text-center">
                            <button
                              class="btn btn-primary w-md waves-effect waves-light"
                              type="submit"
                            >
                              <span
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                                v-if="submitted == true"
                              ></span>
                              Send Reset Email
                            </button>
                          </div>

                          <div class="mt-4 text-center">
                            <router-link to="/login" class="text-muted">
                              <i class="mdi mdi-arrow-left mr-1"></i> Back to
                              Login
                            </router-link>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
